<!-- Container-fluid starts -->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <form [formGroup]="registerForm" class="form theme-form" (ngSubmit)="register()">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">Type</label>
                                    <div class="col-sm-9">
                                        <select (change)="onUpdateTypeChange()" formControlName="type" class="form-select" 
                                        [ngClass]="{ 'is-invalid': submitted && f['type'].errors }" required>
                                            <option value="">Select type</option>
                                            <option *ngFor="let item of updateTypes" value="{{item}}">{{item}}</option>
                                        </select>
                                        <div *ngIf="f['type'].errors" class="invalid-feedback">
                                            <div *ngIf="f['type'].errors['required']">Type is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="!isDiscountEnabled">
                                    <label class="col-sm-3 col-form-label">Discount</label>
                                    <div class="col-sm-9">
                                        <input formControlName="discount" type="number" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f['discount'].errors }"
                                            placeholder="Please enter discount amount" required>
                                        <div *ngIf="f['discount'].errors" class="invalid-feedback">
                                            <div *ngIf="f['discount'].errors['required']">Client name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isDiscountEnabled">
                                    <label class="col-sm-3 col-form-label">Payment Date</label>
                                    <div class="col-sm-9">
                                        <input formControlName="paymentDate" type="date" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f['paymentDate'].errors }"
                                            placeholder="Please enter name" required>
                                        <div *ngIf="f['paymentDate'].errors" class="invalid-feedback">
                                            <div *ngIf="f['paymentDate'].errors['required']">Pyament date is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row" [hidden]="isDiscountEnabled">
                                    <label class="col-sm-3 col-form-label">Amount</label>
                                    <div class="col-sm-9">
                                        <input formControlName="paymentDone" type="number" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f['paymentDone'].errors }"
                                            placeholder="Please payment amount" required>
                                        <div *ngIf="f['paymentDone'].errors" class="invalid-feedback">
                                            <div *ngIf="f['paymentDone'].errors['required']">Amount is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="col-sm-9 offset-sm-3">
                            <button type="submit" class="btn btn-primary me-1">Submit</button>
                            <button type="button" (click)="closePopup()" class="btn btn-light">Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends -->